import React from 'react';
import styled from 'styled-components';

import PresetButton from '../../../PresetButton';

import type { IStartDatePreset } from './types';

export const StartDatePreset = (props: IStartDatePreset): JSX.Element => {
  const { name, title, disabled, isSelected, handleClick, isMobile } = props;

  return (
    <StyledPresetButton
      disabled={disabled}
      isSelected={isSelected}
      handleClick={() => {
        handleClick(name);
      }}
      isMobile={isMobile}
    >
      {title}
    </StyledPresetButton>
  );
};

const StyledPresetButton = styled(PresetButton)`
  white-space: nowrap;
  width: fit-content;
`;
